import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';

class LeadDetailHeader extends Component {
    render() {
        const { t } = this.props;
        return (
            <header className="lead-detail-header">
                <div>
                    <p>{this.props.leadData.firstContact}</p>
                    <h1 className="lead-detail-title">{this.props.leadData.firstName} {this.props.leadData.lastName}</h1>
                </div>
                <div className="lead-state-select">
                    {this.renderSaleAmount()}
                    <select onChange={this.props.onStateChange}
                            value={this.props.leadData.state}>
                        <option value='WON'>{t('lead_state.won')}</option>
                        <option value='OPEN'>{t('lead_state.open')}</option>
                        <option value='LOST'>{t('lead_state.lost')}</option>
                        <option value='NOT_APPLICABLE'>{t('lead_state.not_applicable')}</option>
                    </select>
                </div>
            </header>
        )
    }

    renderSaleAmount() {
        if (this.props.leadData.state === 'WON' && this.props.leadData.saleAmount !== '') {
            return <p className="amount">{this.props.leadData.saleAmount}</p>;
        } else {
            return null;
        }
    }
}

export default withTranslation()(LeadDetailHeader);